import { createContext, ReactNode } from "react";

/**
 * Hands the list controls rendered by the portfolio page (search, sort,
 * layout switch) down to the new-look assets / positions layouts.
 */
export const NewLookPortfolioContext = createContext<
  | {
      listActions?: ReactNode;
    }
  | undefined
>(undefined);
